import { Menu } from '@mui/material';
import { useLocation } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { PersonOutlineOutlined, LoginOutlined } from '@mui/icons-material';
import { useActions } from 'store';
import { logout } from 'store/session/actions';
import { PATH } from 'routes/path';

import { UserMenuProps } from './types';
import { UserMenuItem } from './UserMenuItem';

export const UserMenu = ({ onMenuClose, ...props }: UserMenuProps) => {
    const actions = useActions({ logout });
    const navigate = useNavigate();
    const location = useLocation();

    const logoutHandler = () => {
        actions.logout();
        onMenuClose();
    };

    const goToHandler = (path: string) => () => {
        navigate(path);
        onMenuClose();
    };

    return (
        <Menu {...props} sx={{ '& .MuiPaper-root': { width: '260px' } }}>
            <UserMenuItem
                title="Personal Information"
                icon={PersonOutlineOutlined}
                onClick={goToHandler(PATH.USER_PROFILE)}
                isActive={location.pathname.includes(PATH.USER_PROFILE)}
            />
            <UserMenuItem title="Logout" icon={LoginOutlined} onClick={logoutHandler} />
        </Menu>
    );
};
